import * as React from 'react';
import translate from '../../../../locale/translate';

import { renderEmpty } from '../../common/Render';

import { IReportSettings, SU } from '../../../../interfaces';

import ISettings from './ISettings';
import IWidgetProps from './IWidgetProps';
import SoftwareTable from './SoftwareTable';


interface IProps extends IWidgetProps {
    settings: ISettings;
}

export default class Widget extends React.Component<IProps, {}> {
    static propTypes = {
        systems: React.PropTypes.array.isRequired,
        settings: React.PropTypes.object.isRequired,
        reportSettings: React.PropTypes.object.isRequired,
    };

    accumulateCategoriesByState(categories, state) {
        if(!categories || !categories.length) { return []};
        return categories.filter(category => {
            return category.state == state;
        }).map(category => category.name);
    }

    listFaultyCategories(system: SU.ISystem, settings: ISettings) {
        if(!system.suInformation) { return; }
        let retVal = [];

        let categoriesInProgress = this.accumulateCategoriesByState(system.suInformation.categories, 'IN_PROGRESS');
        let categoriesError = this.accumulateCategoriesByState(system.suInformation.categories, 'ERROR');

        if(categoriesInProgress.length || (!categoriesInProgress.length && settings.displayEmptySections)) {
            let value = categoriesInProgress.join(', ');
            if(!categoriesInProgress.length) {
                value = translate.gettext('no categories in progress');
            }

            retVal.push(<p key="1" className="m-t-n-sm"><small><strong>{translate.gettext(`The following categories were in progress while this report was generated`)}</strong><br />{value}</small></p>);
        }

        if (categoriesError.length || (!categoriesError.length && settings.displayEmptySections)) {
            let value = categoriesError.join(', ');
            if(!categoriesError.length) {
                value = translate.gettext('no categories with errors');
            }

            retVal.push(<p key="2" className="m-t-n-sm"><small><strong>{translate.gettext(`The following categories had an error while this report was generated`)}</strong><br />{value}</small></p>);
        }

        return retVal;
    }

    renderData(nodes: SU.ISystem[], settings: ISettings, reportSettings: IReportSettings) {
        const byParent = nodes.reduce((map, node) => {
            const parentId = node._searchIdx.parentNames.slice(2).join(' / ');

            if (!map[parentId]) {
                map[parentId] = [];
            }

            map[parentId].push(node);

            return map;
        }, {});

        const parents = Object.keys(byParent).sort();

        return parents.map((parent) => {
            const parentKey = `parent-${parent}`;

            const children = byParent[parent].map((node) => {
                const nodeKey = `node-${node.id}`;
                return (
                    <div className="m-b-lg" key={nodeKey}>
                        <SoftwareTable title={node.name} software={node.patches} settings={settings} />
                        {this.listFaultyCategories(node, settings)}
                    </div>
                );
            });

            return (
                <div key={parentKey} className="space-xl">
                    <h4>{parent}</h4>
                    {children}
                </div>
            );
        });
    }

    render() {
        let { systems } = this.props;
        const { settings, reportSettings } = this.props;

        systems = systems.filter((system: SU.ISystem) => {
            if(!system.suInformation || !system.suInformation.enabled) {
                return false;
            }
            if (!settings.displaySystemsWithoutPatches && (!system.patches || !system.patches.length)) {
                return false;
            }

            return true;
        });

        let renderedData;
        if (systems && systems.length) {
            renderedData = this.renderData(systems, settings, reportSettings);
        } else {
            renderedData = renderEmpty();
        }

        return (
            <div>
                {renderedData}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/su/listPatches/Widget.tsx